<template lang="pug">
  component(
    v-bind="componentProps",
    ref="menuElement",
  )
    router-link(itemprop="url" :to="path")
      span(itemprop="name") {{name}}
      SolidSortDownIcon(v-if="hasChildren").svg-icon.sort-down-icon
    ul.menu.vertical(
      v-if="hasChildren",
      itemscope,
      itemtype="https://schema.org/SiteNavigationElement",
    )
      template(
        v-for="(subMenuItem, index) in children",
      )
        router-link(
          v-if="subMenuItem.path.startsWith('/')"
          :key="index"
          tag="li",
          :to="subMenuItem.path",
        )
          a(itemprop="url")
            span(itemprop="name") {{subMenuItem.name}}
        li(
          v-else
          :key="index"
        )
          a(
            :href="subMenuItem.path"
            :target="checkHost(subMenuItem.path) ? '_self' : '_blank'"
          ) {{subMenuItem.name}}
</template>

<script>
import SolidSortDownIcon from 'images/svg-icons/solid-carrot.svg';
import CONFIG from 'Config';

export default {
  name: 'TheHeaderMenuItem',
  components: { SolidSortDownIcon },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true,
    },
    path: {
      type: String,
    },
    children: {
      default: () => ([]),
      type: Array,
    },
  },
  computed: {
    hasChildren() {
      return this.children.length;
    },
    componentProps() {
      if (this.hasChildren) return { is: 'li' };
      return {
        is: 'router-link',
        to: this.path,
        tag: 'li',
      };
    },
  },
  methods: {
    checkHost(path) {
      return path.startsWith(CONFIG.urls.frontend);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import '~Styles/_variables'
  li
    margin: 0 15px
    position: relative
    display: flex
    align-items: center
    @media screen and (max-width: 1024px)
      margin: 0 10px
    &:last-child
      margin-right: 0
    a
      padding: 25px 0
      font-size: 14px
      .sort-down-icon
        margin-left: 4px
        position: relative
        top: -3px
        width: sizeInRem(6)
        height: sizeInRem(4)
        fill: $primary
    &:first-child
      margin-left: 0
    &:last-child
      ::v-deep .menu
        li
          width: 160px !important
</style>
